import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import itemActions from '../actions/item'

export const useItem = () => {
  const data = useSelector((state) => {
    return get(state, 'app.itemManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(itemActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
